// extracted by css-extract-rspack-plugin
export default {"cls1":"ExportFormatModal-cls1_U6z","cls2":"ExportFormatModal-cls2_ZON ExportFormatModal-cls1_U6z"};